import React from 'react';
import { useTranslation } from '@/hooks/useTranslation';

const ContentSection = () => {
  const { t } = useTranslation();

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-100">
      <div className="text-center">
        <h1 className="text-4xl font-bold mb-4">{t('notFoundPage.content.title')}</h1>
        <p className="text-xl text-gray-600 mb-4">{t('notFoundPage.content.message')}</p>
        <a href="/" className="text-blue-500 hover:text-blue-700 underline">
          {t('notFoundPage.content.returnHome')}
        </a>
      </div>
    </div>
  );
};

export default ContentSection; 